import { render, staticRenderFns } from "./overseasItem.vue?vue&type=template&id=03464e04&scoped=true&"
import script from "./overseasItem.vue?vue&type=script&lang=js&"
export * from "./overseasItem.vue?vue&type=script&lang=js&"
import style0 from "./overseasItem.vue?vue&type=style&index=0&id=03464e04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03464e04",
  null
  
)

export default component.exports